"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.929 4.929A9.934 9.934 0 0112 2a9.936 9.936 0 017.071 2.929A9.936 9.936 0 0122 11.999h-2a7.949 7.949 0 00-2.343-5.656A7.949 7.949 0 0012 4a7.947 7.947 0 00-5.657 2.343l2.122 2.121-6.364.708.707-6.364 2.121 2.12zM11.999 20a7.947 7.947 0 005.658-2.343l-2.121-2.121 6.364-.708-.708 6.364-2.121-2.121A9.933 9.933 0 0112 22a9.936 9.936 0 01-7.071-2.929A9.936 9.936 0 012 12.001h2c0 2.136.832 4.145 2.343 5.656A7.948 7.948 0 0012 20z" }), "Retry");
//# sourceMappingURL=Retry.js.map